type DetectedTimeFormat = '12-hour' | '24-hour';

function detectTimeFormat(): DetectedTimeFormat {
  const testDate = new Date(Date.UTC(2020, 0, 1, 13, 0, 0));
  const formattedTime = new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: 'numeric',
  }).format(testDate);

  if (formattedTime.includes('PM') || formattedTime.includes('AM')) {
    return '12-hour';
  }
  return '24-hour';
}

export default detectTimeFormat;
